module.exports = __webpack_public_path__ + "img/nye-bevan.844a4534.png";